<div class="main-container">
  <div class="image-section">
    <img src="assets/icons/playground-process.svg" alt="process">
  </div>
  <div class="info-section">
    <div class="info-title">
      Processing results...
      <div class="info-subtitle">
        This may take a few mins </div>
    </div>
  </div>
